/*
  Explore ABC page for FullStack.cash
*/

import React, { useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router-dom'
import { Container, Row, Col, Accordion, Form } from 'react-bootstrap'
import routes from '../data/abc-routes.json'
import Endpoint from '../components/route/Endpoint'

const VERSION = '/v5'
const SERVER = process.env.REACT_APP_ABCSERVER || process.env.ABCSERVER

function ExploreABC () {
  const navigate = useNavigate()
  const [endpointIndex, setEndpointIndex] = useState(null)

  const showEndpoints = (i) => {
    setEndpointIndex(endpointIndex === i ? null : i)
  }

  const changeServer = (e) => {
    const value = e.target.value
    if (value === 'BCHN') {
      navigate('/explore-bchn')
    }
    if (value === 'Testnet') {
      navigate('/explore-testnet')
    }
  }

  return (
    <>
      <Helmet>
        <title>Explore ABC - FullStack.cash</title>
      </Helmet>

      <Container className='py-5'>
        <Row>
          <Col>
            <Form.Select className='mb-4' defaultValue='ABC' onChange={changeServer}>
              <option value='Testnet'>Testnet</option>
              <option value='BCHN'>BCHN</option>
              <option value='ABC'>ABC</option>
            </Form.Select>

            <Accordion>
              {routes.map((route, i) => (
                <Accordion.Item eventKey={i.toString()} key={i}>
                  <Accordion.Header onClick={() => showEndpoints(i)}>
                    <div className='w-100 d-flex justify-content-between align-items-center'>
                      <div>
                        <strong>{route.name}</strong>
                        <br />
                        <small className='text-muted'>{route.description}</small>
                      </div>
                      <a
                        href={route.docUrl}
                        target='_blank'
                        rel='noreferrer'
                        className='btn btn-sm btn-outline-primary'
                        onClick={(e) => e.stopPropagation()}
                      >
                        Find out more
                      </a>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    {endpointIndex === i && (
                      <Endpoint
                        endpoints={route.endpoints}
                        SERVER={SERVER}
                        VERSION={VERSION}
                      />
                    )}
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default ExploreABC
